"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useAriaLiveMessage_1 = require("./useAriaLiveMessage");
exports.useAriaLiveMessage = useAriaLiveMessage_1.default;
var useLocale_1 = require("./useLocale");
exports.useLocale = useLocale_1.default;
//# sourceMappingURL=index.js.map